import {Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { Table } from 'primeng/table';
import { MaterialPage } from 'projects/desktop/src/app/modules/vendor/data/materials-page';
import { MaterialsResponcePage } from 'projects/desktop/src/app/modules/vendor/data/materials-response-page';
import { LocalStorage } from 'ngx-webstorage';
import { SelectItem } from 'primeng/api';
import { Subject, Subscription, timer } from 'rxjs';
import { MaterialsService } from 'projects/desktop/src/app/modules/vendor/data/materials.service';
import { VendorsService } from 'projects/desktop/src/app/modules/vendor/data/vendors.service';
import { MatOrderQuery } from 'projects/desktop/src/app/modules/order/data/mat-order.query';
import { MatOrderStore } from 'projects/desktop/src/app/modules/order/data/mat-order.store';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { MaterialType } from 'projects/desktop/src/app/modules/vendor/data/material-type';
import { ReportsService } from 'projects/app-misc/src/app/modules/reports/data/reports.service';
import { CabinetsComplexityPage } from 'projects/app-misc/src/app/modules/reports/data/cabinets-complexity-page';
import {
  CabinetComplexityVariation
} from 'projects/app-misc/src/app/modules/reports/data/cabinet-complexity-variation';
import {API_URL} from '../../../../../../../core/src/lib/core/utils/tokens';
import {FileService} from '../../../../../../../core/src/lib/misc/data/file/file.service';
import {HttpEventType, HttpProgressEvent, HttpResponse} from '@angular/common/http';
import {ProjectFile} from '../../../project-misc/data/project/project-file';

@Component({
  selector: 'app-cabinets-complexity-view',
  templateUrl: './cabinets-complexity-view.component.html',
  styleUrls: ['./cabinets-complexity-view.component.scss']
})
export class CabinetsComplexityViewComponent implements OnInit, OnDestroy {

  @ViewChild('ct', {static: true})
  cabsTable: Table;

  cabinetComplexityVariation: CabinetComplexityVariation[];
  cabsResponcePage: CabinetsComplexityPage;

  cabsCols: any[] = [];

  types: SelectItem[];
  typeItems: SelectItem[];

  vendors: SelectItem[];
  vendorItems: SelectItem[];

  units: SelectItem[];
  unitItems: SelectItem[];

  colors: SelectItem[];

  loadings = [];

  totalElems: number;
  cabsPerPage = 50;

  showTypes: boolean;

  editSubj = new Subject<CabinetComplexityVariation>();
  loadSubj = new Subject<void>();
  searchQuery: string;

  first: number;
  rows: number;
  footerString: string;

  reportSearchSubj: Subscription;

  constructor(
    @Inject(API_URL) protected apiUrl: string,
    protected el: ElementRef,
    protected reportsService: ReportsService,
    protected fileService: FileService,
    protected matOrderQuery: MatOrderQuery,
    protected matOrderStore: MatOrderStore,
    public router: Router
  ) {
    this.cabsCols = [
      {field: 'cabinetName', header: 'Cabinet Name'},
      {field: 'complexityType', header: 'Complexity Type'},
      {field: 'complexityStyle', header: 'Complexity Style'},
      {field: 'complexityMultiplier', header: 'Complexity Multiplier'},
      {field: 'overallComplexity', header: 'Overall Complexity'}
    ];

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    timer(1).subscribe(emit => {
      this.cabsPerPage = Math.max(0, Math.trunc((this.el.nativeElement.offsetHeight - 60) / 45));
      if(this.cabsPerPage === 0) {
        this.cabsPerPage = 50
      }

      this.showTypes = false;

      this.subToEditable();
      this.subToLoadMaterials()

      this.reportSearchSubj = this.matOrderQuery.searchQuery$.subscribe(query => {
        if(query !== '') {
          this.searchQuery = query
          this.matOrderStore.updateSearchQuery('')
        }
      })

    })
  }

  subToLoadMaterials() {
    this.loadSubj.pipe(debounceTime(500)).subscribe(emit => {
      this.loadMaterials()
    })
  }

  topSearchBar() {
    this.loadSubj.next()
  }

  changeFilter() {
    this.loadSubj.next()
  }

  deleteQuery() {
    this.searchQuery = ''
    this.loadMaterials()
  }

  downloadXLSX() {
    const url = `/file/for-cabinets-complexity/download`;
    window.open(this.apiUrl + url, '_blank');
  }

  uploadXLSX(files: File[], filesForm?) {
    this.loadings.push('mat')
    this.fileService.postFile<string>(`/file/for-cabinets-complexity/upload`, 'files', files).subscribe(httpEvent => {
      if (httpEvent.type === HttpEventType.Response) {
        this.topSearchBar()
        this.loadings.pop()
      }
      filesForm.clear();
    }, error => {
      this.loadings.pop()
    })
  }

  loadMaterials(event?) {

    this.loadings.push('mat')

    this.first = event?.first ? event.first : 0;

    this.reportsService.searchCabinetsComplexityTypes(this.first / this.cabsPerPage, this.cabsPerPage, this.searchQuery).subscribe(cabPage => {
      this.cabsResponcePage = cabPage
      this.cabinetComplexityVariation = cabPage.content

      this.totalElems = cabPage.totalElements

      this.loadings.pop();
      this.countFooter();

      if(!event) {
        this.cabsTable.reset();
      }
    }, error => {

      this.loadings.pop();
    });
  }

  subToEditable() {
    this.editSubj.pipe(
      debounceTime(250)
    ).subscribe(cabs => {
      this.reportsService.updateComplexity(cabs).subscribe(emit => {
      })
    })
  }

  startEdit(event) {

    const tempInputs = (this.el.nativeElement as HTMLInputElement).getElementsByClassName('material-input-text');
    if(tempInputs) {
      timer(1).subscribe(emit => {
        const input = tempInputs[0] as HTMLInputElement
        if(input) {

          input.focus()
          input.setSelectionRange(0, input.value.length);
        }
      })
    }
  }

  countFooter() {
    let max = this.cabsPerPage * (this.first / this.cabsPerPage + 1);
    max = max < this.totalElems ? max : this.totalElems;

    this.footerString = `${this.first + 1} to ${max} of ${this.totalElems}`;
    // if()
  }


  editMaterial(rowData: CabinetComplexityVariation) {
    rowData.complexityType = rowData.complexityType ? parseFloat(rowData.complexityType + '') : 0
    rowData.complexityStyle = rowData.complexityStyle ? parseFloat(rowData.complexityStyle + '') : 0
    rowData.complexityMultiplier = rowData.complexityMultiplier ? parseFloat(rowData.complexityMultiplier + '') : 0
    rowData.overallComplexity = rowData.complexityStyle * rowData.complexityMultiplier
    this.editSubj.next(rowData)
  }

  ngOnDestroy(): void {
    this.reportSearchSubj.unsubscribe()
  }
}
